import { useEffect, useState } from 'react';

import { KingdomResponse, Province } from '../@types/KingdomResponse';
import { useIntelState } from '../context/IntelState';
import RestUtilities from '../services/RestUtilities';

export const useRecentIntel = () => {
  const { intelState } = useIntelState();
  const [data, setData] = useState<Province[] | undefined>(undefined);
  const [server, setServer] = useState(1);
  const getRecentData = async (server: number) => {
    const response = await RestUtilities.get(
      `Kingdom/v1/Recent?server=${server}`
    );
    if (response.ok) {
      const kdResponse: KingdomResponse[] = response.content;
      const provinces: Province[] = [];
      kdResponse.forEach((kd: KingdomResponse, i: number) => {
        kd.provinces.forEach((p: Province) => {
          p.id = (i + 1) * 100 + p.slot;
          provinces.push(p);
        });
      });
      setData(provinces);
      setServer(server);
    }
  };

  useEffect(() => {
    if (!data || server !== intelState.server) {
      getRecentData(intelState.server);
    }
  }, [data, intelState.server, server]);

  return data;
};
